/**
 * Headline marketing statistics.
 *
 * These figures were previously hardcoded in three places (Hero.jsx,
 * TrustSection.jsx and seoContent.js) and had drifted out of any single
 * source of truth. They are centralised here so that correcting a number is
 * one edit rather than a search-and-replace.
 *
 * IMPORTANT - these are public claims on a healthcare site.
 *
 * "50K+ Happy Patients", "200+ Expert Doctors" and "50+ Partner Hospitals"
 * are substantive advertising claims. Advertising regulators in the markets
 * this site targets (ASA/CAP in the UK, ASCI in India, ACCC in Australia,
 * the FTC in the US) require that a quantified claim be capable of
 * substantiation with evidence held before publication.
 *
 * Verify each figure against your own records and correct it here. If a
 * figure cannot be evidenced, either replace it with one that can be, or set
 * `SHOW_HEADLINE_STATS` to false to hide the stat strip entirely until it can.
 */

export const SHOW_HEADLINE_STATS = true;

export const siteStats = {
  patients: {
    value: "50K+",
    label: "Happy Patients",
  },
  doctors: {
    value: "200+",
    label: "Expert Doctors",
  },
  hospitals: {
    value: "50+",
    label: "Partner Hospitals",
  },
};
